/**
 * @flow
 */
import { Alert, Box, Typography } from '@mui/material';
import { I18n } from 'utils/i18n';
import React from 'react';

type Props = {
  app?: Object,
  message: any,
};

const OAuthError = ({ app, message }: Props) => {
  return (
    <div>
      <Alert severity="error" sx={{ mb: 3 }}>
        {I18n.t('OAuth.Something went wrong when authorizing', { name: app?.name || 'App' })}
      </Alert>
      <Typography>
        <strong>{I18n.t('OAuth.Error details')}</strong>
      </Typography>
      <Box
        sx={{
          bgcolor: 'secondary.ultraLight',
          borderRadius: '4px',
          mt: 1,
          p: 2,
        }}
      >
        {message}
      </Box>
    </div>
  );
};

export default OAuthError;
